module.exports = __webpack_public_path__ + "img/shopify.9176876a.png";